import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import VintageLayout from '../layout/VintageLayout';

export const LoginPage: React.FC = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            const { data } = await api.post('/auth/login', { email, password });
            login(data.token, data);
            toast.success('Connexion réussie !');
            navigate('/dashboard');
        } catch (error: any) {
            toast.error(error.response?.data?.message || 'Erreur de connexion');
        }
    };

    return (
        <VintageLayout>
            <div className="min-h-screen flex items-center justify-center p-6">
                <div className="w-full max-w-md relative z-10 animate-fade-in-up p-8 rounded-2xl border border-gold-500/30 bg-black/60 backdrop-blur-md shadow-[0_0_30px_rgba(0,0,0,0.5)]">
                    <div className="text-center mb-8">
                        <div className="flex justify-center mb-6">
                            <img
                                src="/assets/logo-text.png"
                                alt="Réminiscence"
                                className="h-20 w-auto brightness-0 invert drop-shadow-[0_0_10px_rgba(212,175,55,0.5)]"
                            />
                        </div>
                        <h2 className="text-3xl font-serif font-bold text-cream-100 mb-2">Connexion</h2>
                        <p className="text-cream-200/60 italic font-serif">"Le souvenir est le parfum de l'âme. George Sand"</p>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label className="block mb-2 text-gold-100 font-semibold font-serif">Email ou Nom d'utilisateur</label>
                            <input
                                type="text"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full bg-neutral-900/50 border border-gold-500/30 rounded-lg px-4 py-3 text-cream-100 placeholder-neutral-500 focus:outline-none focus:border-gold-500 focus:ring-1 focus:ring-gold-500 transition-all font-serif"
                                placeholder="Email ou Pseudo"
                                required
                            />
                        </div>
                        <div>
                            <label className="block mb-2 text-gold-100 font-semibold font-serif">Mot de passe</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full bg-neutral-900/50 border border-gold-500/30 rounded-lg px-4 py-3 text-cream-100 placeholder-neutral-500 focus:outline-none focus:border-gold-500 focus:ring-1 focus:ring-gold-500 transition-all font-serif"
                                placeholder="••••••••"
                                required
                            />
                        </div>
                        <div className="text-right">
                            <Link to="/forgot-password" className="text-sm text-gold-400/80 hover:text-gold-300 transition-colors font-serif italic">
                                Mot de passe oublié ?
                            </Link>
                        </div>
                        <button
                            type="submit"
                            className="btn-vintage w-full flex justify-center items-center gap-2 group py-3 text-lg"
                        >
                            <span>Me connecter</span>
                            <span className="group-hover:translate-x-1 transition-transform">→</span>
                        </button>
                    </form>
                    <div className="mt-8 text-center pt-6 border-t border-gold-500/20">
                        <p className="text-cream-200/60">
                            Première visite ?{' '}
                            <Link to="/register" className="text-gold-400 font-bold hover:text-gold-300 transition-colors font-serif underline decoration-gold-500/50 decoration-2 underline-offset-4">
                                S'inscrire
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
        </VintageLayout>
    );
};
